import { SdirCheckbox, styles, Tooltip } from '@sdir/sds';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

interface PhysicalCertificateProps {
  checked: boolean;
  setChecked: React.Dispatch<React.SetStateAction<boolean>>;
}

const PhysicalCertificate: React.FC<PhysicalCertificateProps> = ({ checked, setChecked }) => {
  const intl = useIntl();

  const setCheckbox = useCallback(() => {
    setChecked(!checked);
  }, [checked, setChecked]);

  return (
    <>
      <Wrapper>
        <Label htmlFor="physicalCert">{intl.formatMessage({ id: 'physical.certificate' })}</Label>
        <Tooltip small>{intl.formatMessage({ id: 'physical.certificate.tooltip' })}</Tooltip>
      </Wrapper>
      <Wrapper>
        <SdirCheckbox onClick={setCheckbox} checked={checked} />
        <p>{intl.formatMessage({ id: 'physical.certificate.required' })}</p>
      </Wrapper>
    </>
  );
};

export default PhysicalCertificate;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

const Label = styled.label`
  font-size: 14px;
  color: ${styles.colors.font.text50};
  font-family: ${styles.fonts.stfMedium};
`;
